var map = {
	"./pr-1.png": "1210",
	"./pr-2.png": "ab15",
	"./pr-3.png": "7c42",
	"./pr-4.png": "c6e5",
	"./pr-5.png": "9f03",
	"./pr-6.png": "4401"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bd3";